import { ActionContext } from 'vuex';
import { IEmailTracker } from '@llws/lift-entity-interfaces';
import { Null, Equal, QueryStringCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';
import { adminRequest } from '@/shared/request-configs/admin-request';

// Base store configuration
const adminGatewayResourcePath: string = '/email-tracking-api/lift/email_tracker';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: QueryStringCommandOptions = {
  relations: [
    {
      path: 'building',
      alias: 'building',
    },
    {
      path: 'building.city',
      alias: 'city',
    },
  ],
};

const defaultGetSingleFilters: QueryStringCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementation<IEmailTracker>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'email-tracker/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,

    async saveEmailTracker(ctx: ActionContext<any, any>, payload: any) {
      await adminRequest.put(`/email-tracking-api/lift/email_tracker?trackAllBuildings=${payload.additional.track}`, payload.data);
    },
  },
};
